import { CreateUIAnalyticsEvent } from "@atlaskit/analytics-next";

export function measureTime<T>(
    fn: () => Promise<T>,
    label: string,
    createAnalyticsEvent: CreateUIAnalyticsEvent
): Promise<T> {
    const start = performance.now();
    return fn().then((result) => {
        const end = performance.now();
        const elapsedTime = (end - start) / 1000;

        createAnalyticsEvent({
            eventType: "track",
            action: "viewed",
            actionSubject: "measureTime",
            containerId: label,
            attributes: {
                start,
                end,
                elapsedTime
            }
        }).fire();
        return result;
    });
}
